import { render } from "./select-payment-method.vue?vue&type=template&id=3c007cb8&scoped=true"
import script from "./select-payment-method.vue?vue&type=script&lang=js"
export * from "./select-payment-method.vue?vue&type=script&lang=js"

import "./select-payment-method.vue?vue&type=style&index=0&id=3c007cb8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c007cb8"]])

export default __exports__